import env from '@/config/env'
import request from '@/router/axios'

/**
 *
 * 短链管理
 */

// 查询分组
export const getShorUrlKindList = () => {
  return request({
    url: `${env.ferryUrl}/short-url-kind/list`,
    method: 'GET'
  })
}

// 新增编辑分组
export const saveShorUrlKind = (data) => {
  return request({
    url: `${env.ferryUrl}/short-url-kind/save-or-update`,
    method: 'POST',
    data
  })
}

// 删除分组
export const deleteShorUrlKind = (data) => {
  const { id } = data || {}
  return request({
    url: `${env.ferryUrl}/short-url-kind/${id}`,
    method: 'DELETE'
  })
}

// 分组排序
export const sortShorUrlKind = (data) => {
  return request({
    url: `${env.ferryUrl}/short-url-kind/sort-list`,
    method: 'POST',
    data
  })
}

// 分页
export const shortLinkPage = (data) => {
  return request({
    url: `${env.ferryUrl}/short-url/page`,
    method: 'POST',
    data
  })
}

// 新增编辑链接
export const saveShortLink = (data) => {
  return request({
    url: `${env.ferryUrl}/short-url/save-or-update`,
    method: 'POST',
    data
  })
}

// 删除
export const deleteShortLink = (data) => {
  const { id } = data || {}
  return request({
    url: `${env.ferryUrl}/short-url/delete/${id}`,
    method: 'DELETE'
  })
}

// 修改状态
export const enableShortLink = (data) => {
  return request({
    url: `${env.ferryUrl}/short-url/enable`,
    method: 'POST',
    data
  })
}

// pv
export const statisticShortLink = (data) => {
  return request({
    url: `${env.ferryUrl}/short-url-statistic/data`,
    method: 'POST',
    data
  })
}

// total
export const totalStatisticShortLink = (data) => {
  return request({
    url: `${env.ferryUrl}/short-url-statistic/total-data`,
    method: 'POST',
    data
  })
}

// 日志
export const logShortLink = (data) => {
  return request({
    url: `${env.ferryUrl}/short-url/log-page`,
    method: 'POST',
    data
  })
}
